import { FormattedMessage, useIntl } from "react-intl";
import React, { useState } from "react";
import { API } from "aws-amplify";
import { useAuth } from "../../../../hooks/use-auth";

export const BillingInformation = () => {
  const [isLoading, setIsLoading] = useState(false);
  const intl = useIntl();
  const applicationUrl = process.env.REACT_APP_APPLICATION_URL || "";
  const { user } = useAuth();

  const openStripePortal = () => {
    setIsLoading(true);

    if (user?.customerId) {
      API.post("API", "/stripe/portal", {})
        .then((response) => {
          window.open(response.url, "_blank");
          setIsLoading(false);
        })
        .catch(() => {
          setIsLoading(false);
        });
    } else {
      API.post("API", "/stripe/checkout", {})
        .then((response) => {
          window.open(response.url, "_self");
        })
        .catch(() => {
          setIsLoading(false);
        });
    }
  };

  return (
    <div className={"card mb-5 mb-xl-10"}>
      <div className='card-header border-0 cursor-pointer'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>
            <FormattedMessage id={"USERS.MANAGE_BILLING_TITLE"} />
          </h3>
        </div>
      </div>
      <div id='kt_account_deactivate' className='collapse show'>
        <div className='card-body border-top p-9'>
          <div className='fs-6'>
            <FormattedMessage
              id={"USERS.MANAGE_BILLING_DESCRIPTION"}
              values={{
                userGuideLink: (...chunks: any) => (
                  <a
                    href={`${applicationUrl.replace("https://", "https://static.")}/ug/user-guide_${
                      intl.locale
                    }.pdf`}
                    target='_blank'
                    rel='noreferrer'
                  >
                    {chunks}
                  </a>
                ),
              }}
            />
          </div>
        </div>
        <div className='card-footer d-flex align-items-center justify-content-end py-6 px-9'>
          <div>
            <button
              className={"btn fw-bold btn-primary"}
              disabled={isLoading}
              onClick={openStripePortal}
            >
              <FormattedMessage id={"USERS.MANAGE_BILLING_BUTTON"} />
              {isLoading && <span className='spinner-border spinner-border-sm align-middle ms-2' />}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
